module.exports = "/packs/003-ac77ab8aad0d2d21d9d0b87c2c3eda94.jpg";